<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{span:24}" :lg="{span:8}">
      <a-card>
        <div slot="title">
          <a-icon type="file-search" />&nbsp; Search
        </div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    @change="searching"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    @change="searching"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                    >{{item.label}}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{span:24}" :lg="{span:16}">
      <DataList
        :loading="loading"
        title="Sales Notification List"
        :manifestLink="toManifest"
        :dataList="dataListOutput"
        :rating="false"
        :disabledCreateEditLink="true"
        :isTransactional="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import Axios from "axios";
import moment from "moment";

export default {
  name: "SalesNotification",
  props: ["prnMenu"],
  data() {
    return {
      loading: true,
      salesNotifList: [],
      storeList: [],
      search: "",
      searchDate: null,
      status: undefined,
      pagination: {
        pageSize: 5,
        size: "small",
      },
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getSalesType",
      "getStatus",
      "getDefaultDateFormat",
    ]),
    dataListOutput() {
      let output = [];

      this.salesNotifList.forEach((data) => {
        output.push({
          title: data.no_salesnotif,
          subdesc: [
            moment(data.tanggal).format(this.getDefaultDateFormat) +
              " - " +
              data.tlc,
            //data.project_nm ? data.project_nm : "-",
            data.deskripsi ? data.deskripsi : "-",
          ],
          status: data.status,
          cancelStatus: data.cancel_sts
            ? data.cancel_sts == 1
              ? "Canceled"
              : data.cancel_sts == 2
              ? "Unusual"
              : null
            : null,
          id: data.id_salesnotif,
          timeline: JSON.parse(data.status_app),
          islistPPrevised: false,
        });
      });

      return output;
    },
    searching() {
      let filteredDataBySearch = [];
      this.salesNotifList = this.storeList;

      if (this.search) {
        this.salesNotifList = this.salesNotifList.filter(
          (obj) =>
            obj.no_salesnotif
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            obj.tlc.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            this.moment(obj.tanggal)
              .format(this.getDefaultDateFormat)
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            obj.status.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        this.salesNotifList = this.salesNotifList.filter(
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (this.searchDate) {
        console.log(moment(this.searchDate).format("YYYY-MM-DD"));
        let searchDate = moment(this.searchDate).format("YYYY-MM-DD");
        this.salesNotifList = this.salesNotifList.filter(
          (obj) => obj.tanggal === searchDate
        );
      }
    },
    toManifest(){
      if(this.$route.path.includes("/financialControl")){
        return "SpclSalesNotificationManifestFin"
      } else{
        return "SpclSalesNotificationManifestAcc"
      }
    }
  },
  methods: {
    moment,
    fetchSalesNotification() {
      Axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/sales_notification",
        params: {
          tlc: this.getAuth.username,
          id: localStorage.getItem("nvky"),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.salesNotifList = response.data.data;
          this.storeList = response.data.data;
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
  mounted() {
    this.fetchSalesNotification();
  },
};
</script>

<style>
</style>